export default "__VITE_ASSET__DF9ZrBR9__"